module.exports = __webpack_public_path__ + "templates-59e97cd7/cover-letter-1-preview-d69fa21cc97e7b7feb470976fb6a2bfe.jpg";